// Site-wide data for Vision Era Construction

export const COMPANY = {
  name: "Vision Era Construction",
  tagline: "Industrial-grade flooring & exterior systems",
  phone: "+1 (647) 773-4508",
  phoneRaw: "+16477734508",
  smsHref: "sms:+16477734508",
  whatsappHref:
    "https://wa.me/16477734508?text=Hi%20Vision%20Era%2C%20I%27d%20like%20to%20request%20a%20quote%20for%20",
  email: "info@visioneraconstruction.ca",
  serviceArea: "Greater Toronto Area, Canada",
  hours: "Mon — Fri · 7:00 AM — 6:00 PM",
};

export const SERVICES = [
  {
    slug: "industrial-resinous",
    title: "Industrial Resinous Flooring",
    short: "Resinous",
    image:
      "/images/dlpqse35.png",
    blurb:
      "Heavy-duty resinous systems engineered for warehouses, manufacturing plants, automotive bays and high-traffic logistics floors.",
    features: [
      "Up to 250 mil thickness",
      "Chemical & abrasion resistant",
      "Static dissipative options",
      "Fast turnaround installation",
    ],
  },
  {
    slug: "residential-flooring",
    title: "Residential Flooring",
    short: "Residential",
    image:
      "/images/9ae3kktf.png",
    blurb:
      "Decorative epoxy chip-flake and metallic systems for garages, basements, gyms and showroom floors — durable, hot-tire resistant, and easy to clean.",
    features: [
      "Full broadcast color chip & flake",
      "Polyaspartic UV-stable topcoat",
      "Hot-tire & impact resistant",
      "1-day install on most garages",
    ],
  },
  {
    slug: "food-grade-urethane",
    title: "Food Grade Cementitious Urethane",
    short: "Urethane",
    image:
      "/images/nto1sybh.png",
    blurb:
      "Food-safety-compliant cementitious urethane mortar systems for food & beverage processing, breweries, dairies and commercial kitchens.",
    features: [
      "Thermal shock resistant",
      "Bacterial growth inhibition",
      "Steam clean & wash-down rated",
      "Integral cove base detailing",
    ],
  },
  {
    slug: "exterior-stucco",
    title: "Exterior Stucco Systems",
    short: "Stucco",
    image:
      "/images/vmec2zqr.png",
    blurb:
      "Traditional and synthetic stucco facades engineered for durability, energy performance and architectural detail.",
    features: [
      "3-coat & one-coat systems",
      "EIFS integration",
      "Custom textures & finishes",
      "Weatherproof envelope detailing",
    ],
  },
];

export const STATS = [
  { label: "Projects delivered", value: "92" },
  { label: "Sq ft installed", value: "645K" },
  { label: "Repeat clients", value: "92%" },
  { label: "GTA cities served", value: "30+" },
];

export const PROJECTS = [
  {
    id: "p1",
    title: "Dairy Plant — Urethane Mortar Floor",
    category: "Urethane",
    location: "Mississauga, ON",
    image:
      "/images/r7wygzwf.png",
    area: "48,000 sq ft",
  },
  {
    id: "p2",
    title: "Auto Manufacturing — Static Dissipative Epoxy",
    category: "Resinous",
    location: "Oakville, ON",
    image:
      "/images/mn73hhiy.png",
    area: "120,000 sq ft",
  },
  {
    id: "p3",
    title: "Craft Brewery — Cove Base & Drains",
    category: "Urethane",
    location: "Etobicoke, ON",
    image:
      "https://images.unsplash.com/photo-1779517226271-72b1e4ff0884?auto=format&fit=crop&w=1600&q=80",
    area: "22,500 sq ft",
  },
  {
    id: "p4",
    title: "Modern Residence — Smooth Stucco Envelope",
    category: "Stucco",
    location: "Vaughan, ON",
    image:
      "/images/d0l7uee1.png",
    area: "7,800 sq ft",
  },
  {
    id: "p5",
    title: "Custom Garage — Chip Flake Epoxy System",
    category: "Residential",
    location: "Brampton, ON",
    image:
      "/images/rvml6bt3.png",
    area: "1,200 sq ft",
  },
  {
    id: "p6",
    title: "Logistics Hub — Heavy-Duty Resinous Coat",
    category: "Resinous",
    location: "Markham, ON",
    image:
      "https://images.unsplash.com/photo-1772305336606-989a457ffbae?auto=format&fit=crop&w=1600&q=80",
    area: "180,000 sq ft",
  },
  {
    id: "p7",
    title: "Commercial Plaza — Exterior Stucco Restoration",
    category: "Stucco",
    location: "Richmond Hill, ON",
    image:
      "https://images.unsplash.com/photo-1503387762-592deb58ef4e?auto=format&fit=crop&w=1600&q=80",
    area: "31,200 sq ft",
  },
  {
    id: "p8",
    title: "Modern Basement Suite — Metallic Epoxy",
    category: "Residential",
    location: "Toronto, ON",
    image:
      "/images/9ae3kktf.png",
    area: "2,400 sq ft",
  },
];

export const TESTIMONIALS = [
  {
    quote:
      "Vision Era resurfaced our entire production floor over a weekend shutdown. Zero delays, zero rework — the floor still looks brand new.",
    name: "Marcus Reilly",
    role: "Plant Manager, Northbridge Manufacturing",
  },
  {
    quote:
      "The crew handled our food-safety inspection requirements like they wrote the spec. The urethane cove detailing is the cleanest we've ever seen.",
    name: "Diana Esposito",
    role: "Operations Director, Crestview Dairy",
  },
  {
    quote:
      "From estimate to final walkthrough they were transparent, on-time and meticulous. The stucco finish on our build matches the architect's renderings exactly.",
    name: "Hugo Marín",
    role: "General Contractor, Marín Build Group",
  },
];

export const SERVICE_OPTIONS = SERVICES.map((s) => ({
  value: s.slug,
  label: s.title,
}));

export const PROJECT_SIZE_OPTIONS = [
  { value: "under-5k", label: "Under 5,000 sq ft" },
  { value: "5k-25k", label: "5,000 – 25,000 sq ft" },
  { value: "25k-100k", label: "25,000 – 100,000 sq ft" },
  { value: "over-100k", label: "Over 100,000 sq ft" },
];
